<template>
<div container--fluid>
    <v-layout>
        <MembershipModule></MembershipModule>
    </v-layout>
</div>
</template>

<script>
import MembershipModule from '@modules/membership/index.vue';

export default {
    name: 'membership',
    components: {
        MembershipModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
